import { shoppingApi } from 'app/src/services/welfareportal'
import { FringeBenefitSpinner } from 'app/src/shared/components'
import { euroFormatterIt } from 'app/src/shared/helpers'
import { useTranslation } from 'react-i18next'

export function GoodAndServiceRightPanelSide(props: {
  order: shoppingApi.OrderDetails
  className?: string
  showFringeSpinner?: boolean
  showCredit?: boolean
}) {
  const creditApiResponse = shoppingApi.useCreditGet(
    {},
    {
      meta: {
        skip404Errors: true,
      },
    },
  )
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  return (
    <div className={props.className ?? 'col-span-12 mx-auto flex w-full justify-start p-2 lg:col-span-6 lg:pl-8'}>
      <div className='pl-12 lg:pl-0'>
        {props.order?.priceDetails && (
          <>
            <div className='h-[28px]'>{t('GoodAndService.priceDescription')}</div>
            <div className='mt-4 text-2xl font-bold'>
              {props.order.priceDetails.grossPrice > 0
                ? euroFormatterIt.format(props.order.priceDetails.grossPrice)
                : t('Common.freeAmount')}
            </div>
            {typeof props.showCredit !== 'undefined' && props.showCredit && (
              <div className='mt-4'>
                {t('Common.balanceDescription', {
                  AVAILABLECREDIT: creditApiResponse.data?.creditByServiceCategory?.welfareArt100.available
                    ? euroFormatterIt.format(creditApiResponse.data.creditByServiceCategory.welfareArt100.available)
                    : '-',
                })}
              </div>
            )}
          </>
        )}
      </div>
      {typeof props.showFringeSpinner !== 'undefined' && props.showFringeSpinner && (
        <div className='lg:pl-6'>
          <FringeBenefitSpinner pt={{ title: { hide: true } }} />
        </div>
      )}
    </div>
  )
}
